import styled from "styled-components"

import Button from "../Button"
import {spacingCss, SpacingProps} from "../global/css"

interface StyledProps extends SpacingProps {
  isToggled: boolean,
  rounded?: boolean
}

const StyledButton = styled(Button)<StyledProps>`
  ${({theme, isToggled, rounded}) => `
    background-color: transparent;
    padding: ${rounded ? `14px ${theme.spacing.four}` : theme.spacing.one};
    border: 1px solid${rounded ? theme.colors.filterChip : theme.colors.greys.medium};
    border-radius: ${rounded ? 27 : 6}px;
    color: ${theme.colors.filterChip};
    &:hover {
      background-color: ${theme.colors.filterChip};
      color: ${theme.colors.greys.white};
    }
    &:active, &:focus {
      background-color: transparent;
      color: ${theme.colors.filterChip};
      path {
        transition: fill 0.25s ease;
        fill: ${theme.colors.filterChip};
      }
    }
    path {
      transition: fill 0.25s ease;
      fill: ${theme.colors.filterChip};
    }
    ${isToggled && `
      background-color: ${theme.colors.filterChip};
      color: ${theme.colors.greys.white};
      path {
        transition: fill 0.25s ease;
        fill: ${theme.colors.greys.white};
      }
      &:hover {
        background-color: ${theme.colors.filterChip};
        color: ${theme.colors.greys.white};
      }
      &:active, &:focus {
        background-color: ${theme.colors.filterChip};
        color: ${theme.colors.greys.white};
        path {
          transition: fill 0.25s ease;
          fill: ${theme.colors.greys.white};
        }
      }
    `}
    ${spacingCss}
  `}
`

export default StyledButton
